module.exports = __webpack_public_path__ + "assets/img/yinzhang.4ff966b1.png";